module.exports = __webpack_public_path__ + "8705af35e1f18dd3d3920bed509b9096.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/washs/wash-9.jpg
// module id = 83
// module chunks = 0